import Vue from 'vue';
import VueResource from 'vue-resource';
import { Indicator } from 'mint-ui';
Vue.use(VueResource);
Vue.http.interceptors.push(function(request, next){
  // 跨域携带cookie
  request.credentials = true;
    //var ticketId = localStorage.getItem('ticketId');
    var access_token = localStorage.getItem('access_token');
    request.headers.set('token', access_token);
    Indicator.open('加载中...');  
    next(function(response){
        Indicator.close();
        if(response.body=='NotLogged'){
          localStorage.removeItem("access_token");
            window.location.href="/mobile/index.html";
        }
        return response;
    })
})
  





// WEBPACK FOOTER //
// ./src/js/interceptors.js